<template>
  <v-app-bar
      color="white"
      dark
      fixed class="big-app-header">
    <b-link class="navbar-brand">
      <img
          @click="onClickLogo()"
          class="navbar-brand-full ms-5"
          src="@/assets/images/ic-logo-header.svg"
          height="64"
      />
    </b-link>

    <change-language class="ms-auto"/>
    <dropdown-account class="mx-5"/>

  </v-app-bar>
</template>
<script>
import DropdownAccount from "./DefaultHeader.DropdownAccount.vue";
import ChangeLanguage from "./DefaultHeader.ChangeLanguage.vue";

export default {
  name: "DefaultHeader",
  components: {
    DropdownAccount,
    ChangeLanguage
  },
  props:{
    onClickLogo: {
      type: Function,
      required: true
    },
  },
};
</script>

<style>
.big-app-header {
  height: 64px;
}

</style>